import { useEffect, useMemo, useState } from 'react';
import type * as Y from 'yjs';
import { extractNodesAndEdgesFromDoc } from '../utils/snapshotToScene';
import { ORG_CUSTOM_FIELD_OVERRIDES_MAP, PROJECTED_LAYOUT_MAP, PROJECTED_POSITIONS_MAP } from '../core/canvas/projectedLayout';
import type { ProjectionPresentation } from '../core/canvas/composeProjectedScene';

/** Observe only presentation maps; never enable graph-to-Yjs writeback. */
export function useDiagramPresentationScene(doc: Y.Doc | null | undefined, enabled: boolean): ProjectionPresentation {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!enabled || !doc) return;
    const changed = () => setRevision((value) => value + 1);
    const maps = ['shapes', 'connectors', PROJECTED_LAYOUT_MAP, PROJECTED_POSITIONS_MAP, ORG_CUSTOM_FIELD_OVERRIDES_MAP]
      .map((name) => doc.getMap(name));
    maps.forEach((map) => map.observeDeep(changed));
    // Reconcile updates that arrived between render and observer attachment.
    changed();
    return () => {
      maps.forEach((map) => map.unobserveDeep(changed));
    };
  }, [doc, enabled]);
  return useMemo(() => enabled && doc ? extractNodesAndEdgesFromDoc(doc) : { nodes: [], edges: [] }, [doc, enabled, revision]);
}
